import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './components/ui/card';

export const PrivacyPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-16">
      <h1 className="page-title">Privacy Policy e Cookie Policy</h1>
      
      <div className="max-w-4xl mx-auto space-y-6">
        <Card>
          <CardHeader>
            <CardTitle>1. Titolare del Trattamento</CardTitle>
          </CardHeader>
          <CardContent className="prose max-w-none">
            <p className="text-gray-700">
              Il Titolare del trattamento dei dati personali è <strong>EdiliziaMia</strong>, con sede legale in Via Ponte Bloy 10, Caltanissetta, Italy.
            </p>
            <p className="text-gray-700 mt-2">
              Email: ediliziamia@gmail.com<br />
              Telefono: 351 018 4747
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>2. Tipologie di Dati Raccolti</CardTitle>
          </CardHeader>
          <CardContent className="prose max-w-none">
            <p className="text-gray-700 mb-3">
              Il sito raccoglie i seguenti dati personali:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li><strong>Dati di contatto:</strong> nome, cognome, email, numero di telefono</li>
              <li><strong>Dati aziendali:</strong> nome azienda (opzionale)</li>
              <li><strong>Dati di navigazione:</strong> informazioni sui prodotti visualizzati e aggiunti al carrello</li>
              <li><strong>Cookie tecnici:</strong> necessari per il funzionamento del sito</li>
            </ul>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>3. Finalità del Trattamento</CardTitle>
          </CardHeader>
          <CardContent className="prose max-w-none">
            <p className="text-gray-700 mb-3">
              I dati personali sono trattati per le seguenti finalità:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>Evasione richieste di preventivo</li>
              <li>Risposta a richieste di contatto e informazioni</li>
              <li>Gestione ordini e consegne</li>
              <li>Adempimenti di legge e obblighi fiscali</li>
              <li>Miglioramento dei servizi offerti</li>
            </ul>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>4. Base Giuridica del Trattamento</CardTitle>
          </CardHeader>
          <CardContent className="prose max-w-none">
            <p className="text-gray-700">
              Il trattamento dei dati personali si basa sul consenso dell'interessato (art. 6, par. 1, lett. a) del GDPR) e sull'esecuzione di misure precontrattuali adottate su richiesta dell'interessato (art. 6, par. 1, lett. b) del GDPR).
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>5. Conservazione dei Dati</CardTitle>
          </CardHeader>
          <CardContent className="prose max-w-none">
            <p className="text-gray-700">
              I dati personali sono conservati per il tempo necessario a soddisfare le finalità per cui sono stati raccolti. In particolare:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 mt-3">
              <li>Richieste di preventivo: 24 mesi dalla richiesta</li>
              <li>Messaggi di contatto: 12 mesi dal ricevimento</li>
              <li>Obblighi fiscali: 10 anni come previsto dalla legge</li>
            </ul>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>6. Diritti dell'Interessato</CardTitle>
          </CardHeader>
          <CardContent className="prose max-w-none">
            <p className="text-gray-700 mb-3">
              L'interessato ha diritto di:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>Accedere ai propri dati personali</li>
              <li>Rettificare i dati inesatti</li>
              <li>Cancellare i dati (diritto all'oblio)</li>
              <li>Limitare il trattamento</li>
              <li>Opporsi al trattamento</li>
              <li>Ricevere i dati in formato strutturato (portabilità)</li>
              <li>Revocare il consenso in qualsiasi momento</li>
              <li>Proporre reclamo all'Autorità Garante</li>
            </ul>
            <p className="text-gray-700 mt-4">
              Per esercitare i propri diritti, contattare: ediliziamia@gmail.com
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>7. Cookie Policy</CardTitle>
          </CardHeader>
          <CardContent className="prose max-w-none">
            <p className="text-gray-700 mb-3">
              Il sito utilizza i seguenti tipi di cookie:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li><strong>Cookie tecnici:</strong> necessari per il funzionamento del sito (carrello, navigazione)</li>
              <li><strong>Cookie di preferenza:</strong> memorizzano le scelte dell'utente</li>
            </ul>
            <p className="text-gray-700 mt-4">
              Non utilizziamo cookie di profilazione o di terze parti per finalità pubblicitarie.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>8. Sicurezza</CardTitle>
          </CardHeader>
          <CardContent className="prose max-w-none">
            <p className="text-gray-700">
              EdiliziaMia adotta misure di sicurezza tecniche e organizzative adeguate per proteggere i dati personali da accessi non autorizzati, perdita, distruzione o divulgazione.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>9. Modifiche alla Privacy Policy</CardTitle>
          </CardHeader>
          <CardContent className="prose max-w-none">
            <p className="text-gray-700">
              Questa Privacy Policy può essere modificata nel tempo. Le modifiche saranno pubblicate su questa pagina con indicazione della data di ultimo aggiornamento.
            </p>
            <p className="text-gray-700 mt-3">
              <strong>Ultimo aggiornamento:</strong> 12 Novembre 2025
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};